import { createContext, useContext } from 'react';
import noop from 'lodash/noop';
export var PortalActionsContext = /*#__PURE__*/createContext({
  onCreatePortal: noop,
  onDestroyPortal: noop,
  onRegisterPluginContainer: noop
});
export var usePortalActionsContext = function usePortalActionsContext() {
  return useContext(PortalActionsContext);
};